<template>
  <div>
      <div v-if="current_user.permissions.length > 0" id="transactions-list">
        <transaction-monitoring-filter v-if="$can('read','transaction')" :action="filterAction" :query="query_filter"></transaction-monitoring-filter>
        <div>
          <kt-datatable v-if="$can('read','transaction')" v-bind="datatableProps" ref="datatable">
          </kt-datatable>

          <div class="d-flex justify-content-center mt-3">
            <button
                class="btn btn-light border mx-1"
                :disabled="!prevCursor"
                @click="goPrev">
              قبلی
            </button>

            <button
                class="btn btn-light border mx-1"
                :disabled="!nextCursor"
                @click="goNext">
              بعدی
            </button>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import transactionMonitoringFilter from './transaction-monitoring-filter';
import {ApiUrl} from "@/common/api.service";
import {AuthorizationHeader} from "@/common/jwt.service";
import actionsColumn from "@/views/transaction/components/core-action.vue";
import columns from './../datatable/columns'

export default {
  components: {
    transactionMonitoringFilter
  },
  data() {
    return {
      headerAction: {
        left: '10px',
        top: '10px',
        position: 'absolute'
      },
      query_filter: {
        transaction_type: ['zero'],
        per_page: 100
      },
      query_filter_excel: {},
      cursor: null,
      isFirstTimeToLoadStatistics: true,
      excel_filter_form_id: 'excel',
      loading: true,
      nextCursor: null,
      prevCursor: null,
    }
  },
  computed: {
    ...mapGetters('user', [
      'current_user'
    ]),

    datatableProps() {
      return {
        id: "transaction_monitoring_datatable",
        data: {
          type: 'remote',
          source: {
            read: {
              url: ApiUrl.path('admin/transaction/monitoring'),
              method: 'GET',
              headers: AuthorizationHeader,
              map: (res) => {
                this.nextCursor = res.data.next_cursor
                this.prevCursor = res.data.prev_cursor
                return res.data.data
              },
              params: {
                ...this.query_filter,
                cursor: this.cursor,
                per_page: 100
              },
            }
          },
          pageSize: 100,
          serverPaging: true,
          serverFiltering: true,
          serverSorting: true,
        },

        pagination: false,
        sortable: true,
        columns: columns,
        actions: actionsColumn
      }
    },
  },
  methods: {
    goNext() {
      this.cursor = this.nextCursor
      this.reloadTable()
    },
    goPrev() {
      this.cursor = this.prevCursor
      this.reloadTable()
    },
    reloadTable() {
      if (this.$refs.datatable.KTDatatable) {
        this.$refs.datatable.reload()
      }
    },
    filterAction(query) {
      this.loading = true
      this.query = query
      if (this.query.sheba) {
        let sheba = this.query.sheba
        sheba = sheba.split('-').join('')
        sheba = sheba.split(' ').join('')
        sheba = sheba.split('_').join('')

        query.sheba = sheba
      }
      this.query_filter = query

      if (this.$refs.datatable.KTDatatable) {
        this.$refs.datatable.reload()
      }
    }
  },
  mounted(){
    this.loading = false;
  }
}
</script>

<style scoped>
    >>> .kt-datatable.kt-datatable--default > .kt-datatable__pager {
      display: none !important;
    }
</style>
